import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import CookieBanner from '../components/CookieBanner';

const PrivacyAgreement = () => {
  const { t } = useTranslation();

  return (
    <div className="py-32 sm:py-40">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:mx-0">
          <p className="text-base font-semibold uppercase tracking-wide leading-7 text-signal-400">
            {t('privacy-agreement-subtitle')}
          </p>
          <h2 className="mt-2 font-display text-4xl font-extrabold uppercase italic tracking-tight text-ink-100 sm:text-6xl">
            {t('privacy-agreement-title')}
          </h2>
          <p className="mt-6 text-lg leading-8 text-ink-300">
            {t('privacy-agreement-section-2')}
          </p>
          <h3 className="mt-10 font-display text-2xl font-bold uppercase tracking-tight text-ink-100">
            {t('privacy-agreement-subtitle-1')}
          </h3>
          <p className="mt-6 text-lg leading-8 text-ink-300">
            {t('privacy-agreement-section-3')}
          </p>
          <p className="mt-6 text-lg leading-8 text-ink-300">
            {t('privacy-agreement-section-4')}
          </p>
          <h3 className="mt-10 font-display text-2xl font-bold uppercase tracking-tight text-ink-100">
            {t('privacy-agreement-subtitle-2')}
          </h3>
          <p className="mt-6 text-lg leading-8 text-ink-300">
            {t('privacy-agreement-section-5')}
          </p>
          <p className="mt-6 text-lg leading-8 text-ink-300">
            {t('privacy-agreement-section-6')}
          </p>
          <h3 className="mt-10 font-display text-2xl font-bold uppercase tracking-tight text-ink-100">
            {t('privacy-agreement-subtitle-3')}
          </h3>
          <p className="mt-6 text-lg leading-8 text-ink-300">
            {t('privacy-agreement-section-7')}
          </p>
          <p className="mt-6 text-lg leading-8 text-ink-300">
            {t('privacy-agreement-section-8')}
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <Link
              to="/"
              className="rounded-full bg-signal-500 px-6 py-3 text-sm font-bold uppercase tracking-wide text-white shadow-glow transition-colors hover:bg-signal-400"
            >
              {t('privacy-agreement-button-1')}
            </Link>
            <Link
              to="/contacts"
              className="text-sm font-semibold uppercase tracking-wide text-ink-200 transition-colors hover:text-signal-400"
            >
              {t('privacy-agreement-button-2')}{' '}
              <span aria-hidden="true">&rarr;</span>
            </Link>
          </div>
        </div>
      </div>
      <CookieBanner />
    </div>
  );
};

export default PrivacyAgreement;
